import { CompanyInfo } from 'common/types/company';
import { DEFAULT_CURRENCY } from 'components/FeaturedSpreadsheet/constants';

interface GetCurrencyProps {
  companyInfo: CompanyInfo | null | undefined;
  page: string;
}

export const getCurrency = ({ companyInfo, page }: GetCurrencyProps) => {
  const currencyKey = `${page}_currency`;
  return companyInfo?.[currencyKey] ?? DEFAULT_CURRENCY;
};
